import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { AuthenticationService } from "../services/authentication.service";
import { inject } from "@angular/core";
import * as jwt from 'jose';
import {map} from "rxjs";
import {SsoService} from "../services/sso.service";
import {addToHistory} from "../../store/history/history.actions";
import {Store} from "@ngrx/store";

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  const sso = inject(SsoService);
  const store = inject(Store);
  let decodedToken: Record<string, string | number>;
  try {
    decodedToken = jwt.decodeJwt(authService._tokenSubject.value);
  }
  catch {
    decodedToken = { 'exp': 0 }
  }
  const currentDate = new Date()
  const expired = currentDate > new Date(decodedToken['exp'] as number * 1000);
  const hasToken = authService.isLoggedIn();

  console.log("****************Auth Guard****************");
  console.log({
    route: route.routeConfig?.path,
    hasToken,
    expired,
    token: authService._tokenSubject.value,
    decodedToken,
    currentDate
  })

  if (route.routeConfig?.path !== "login" && route.routeConfig?.path !== "sso") {
    return sso.isSSO().pipe(
      map(value => {
        const redirect = value ? "/sso" : "/login";
        if (!hasToken || expired) {
          const statusParam = route.queryParams['status'];


          if(!value) {
            router.navigateByUrl(redirect);
          }
          else {
            const urlTree = router.createUrlTree([redirect], {
              queryParams: statusParam ? { status: statusParam } : {status: "logout"}
            });
            router.navigateByUrl(urlTree);
            console.log("Navigating from auth guard to:", urlTree.toString());
          }

          return false;
        }
        return true;
      })
    );
  } else {
    if (!hasToken || expired) {
      return true;
    }
    router.navigateByUrl("/home");
    return false;
  }
}
